import ArrivalAndDelivery from "@/classes/dashboard/ArrivalAndDelivery";

export default class Dashboard {

    constructor() {

        this.arrivals = {

            totals: new ArrivalAndDelivery(),

            air: {
                totals: new ArrivalAndDelivery()
            },
            road: {
                totals: new ArrivalAndDelivery()
            },
            sea: {
                totals: new ArrivalAndDelivery()
            },
            rail: {
                totals: new ArrivalAndDelivery()
            },
            courier: {
                totals: new ArrivalAndDelivery()
            }

        },

            this.deliveries = {

                totals: new ArrivalAndDelivery(),

                air: {
                    totals: new ArrivalAndDelivery()
                },
                road: {
                    totals: new ArrivalAndDelivery()
                },
                sea: {
                    totals: new ArrivalAndDelivery()
                },
                rail: {
                    totals: new ArrivalAndDelivery()
                },
                courier: {
                    totals: new ArrivalAndDelivery()
                }

            }
    }
}
